import { render, staticRenderFns } from "./space.vue?vue&type=template&id=4b9cda68&scoped=true"
import script from "./space.js?vue&type=script&lang=js&external"
export * from "./space.js?vue&type=script&lang=js&external"
import style0 from "./space.scss?vue&type=style&index=0&id=4b9cda68&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9cda68",
  null
  
)

export default component.exports